export enum ReportStatusEnum {
  DOWNLOADING = "DOWNLOADING",
  CREATION = "CREATION",
  DONE = "DONE",
}

export enum ReportTypeEnum {
  XLSX = "xlsx",
  CSV = "csv",
}
